import React, { useState, useMemo } from "react";
import Button from "@mui/material/Button";
import "../servicesOperation.css";
import InputAutocomplete from "../InputAutocomplete_Form";
import Grid from "@mui/material/Unstable_Grid2";
import Box from "@mui/material/Box";
import {
  options_origen_devolucion,
  options_deposito_destino,
  options_condicion,
  options_sintoma,
  options_aceptamos_devolucion_safe,
  data_aceptamos_devolucion,
} from "../Helper/data_Admin";
import { TextField } from "@mui/material";
import useAuth from "hooks/useAuth";

// Definimos el componente Admin
const Admin_Form_Body_Taller = ({
  formData,
  setFormData,
  isLoading,
  isSubmitting,
  isSubmitSuccessful,
  dataCondicion,
  dataDeposito_destino,
  dataOrigen_devolucion,
  dataSintoma,
  dataAceptamos_Dev,
  handleSubmit,
  // Additional data props for autocomplete fields
  datataller_componente = [],
  datataller_deposito_destino = [],
  datataller_descripcion = [],
  datataller_estado_sku = [],
  datataller_estetica_packaging = [],
  datataller_estetica_producto = [],
  datataller_falla = [],
  datataller_lote = [],
  datataller_motivo_del_scrap = [],
  datataller_reparacion = [],
  datataller_responsable = [],
}) => {
  // Hook de autenticación para obtener permisos del usuario
  const { user } = useAuth();

  // Verificar si el usuario tiene permisos de administrador
  const hasAdminPermission =
    user?.permissions?.includes("ServiceOp:viewSAdmin") || false;
  console.log(formData);

  //Estados para validación de cada input
  const [touched, setTouched] = useState({});
  const [errors, setErrors] = useState({});

  // Función para manejar cambios en los campos del formulario
  const handleFieldChange = (fieldName, value) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [fieldName]: value,
    }));
  };

  // Función para marcar un campo como tocado
  const handleBlur = (id) => {
    setTouched((prevState) => ({
      ...prevState,
      [id]: true,
    }));
    validateField(id, formData[id]);
  };

  const validateField = (id, value) => {
    // Si el valor es nulo o el string vacío, establecer el error
    if (!value) {
      setErrors((prevState) => ({
        ...prevState,
        [id]: "Este campo es obligatorio",
      }));
    } else {
      // Eliminar el error si el campo es válido
      setErrors((prevState) => {
        const newState = { ...prevState };
        delete newState[id];
        return newState;
      });
    }
  };

  //Función para filtrar las opciones de Depósito Destino
  const filterDepositoDestinoOptions = (containsDonato) => {
    if (!containsDonato) {
      // Restablecer a todas las opciones si no hay iniciales
      return;
    }
    //Filtra por aquellas opciones tengan Donato, y filtra las que incluyan "Taller"
    const filteredOptions = dataDeposito_destino.filter(
      (option) =>
        option.name.includes("Donato") && !option.name.includes("Taller"),
    );
    // Aquí podrías actualizar el estado si fuera necesario
  };

  //Captura Inputs Autocomplete
  const handleChangeAutoComplete = (id, newInputValue) => {
    const newId = newInputValue ? newInputValue.id : null;

    setFormData((prevState) => ({
      ...prevState,
      [id]: newInputValue ? newInputValue.id : 0,
    }));

    if (
      id === "numero_serie" ||
      // id === "codigo_barra" ||
      id === "comentarios"
    ) {
      setFormData((prevState) => ({
        ...prevState,
        [id]: newInputValue ? newInputValue : null,
      }));
    }

    setTouched((prevState) => ({ ...prevState, [id]: true }));
    validateField(id, newId);

    //Añadir filtro condicional de Depósito Destino
    if (id === "id_deposito_dest") {
      //Guarda la inicial después del primer "("
      const containsDonato = newInputValue
        ? newInputValue.name.includes("Donato")
        : null;
      filterDepositoDestinoOptions(containsDonato);
    }
  };

  // Selected values for autocomplete fields - using correct field names from formData
  // Campos de Admin_Form_Body
  const origenDevSeleccionado = dataOrigen_devolucion.find(
    (option) => option.id === formData["id_origen_dev"],
  );
  const deposito_dest_Seleccionado = dataDeposito_destino.find(
    (option) => option.id === formData["id_deposito_dest"],
  );
  //   const condicion_Seleccionado = dataCondicion.find(
  //     (option) => option.id === formData["id_condicion"],
  //   );
  const sintoma_Seleccionado = dataSintoma.find(
    (option) => option.id === formData["id_sintoma"],
  );
  //   const aceptamos_dev_Seleccionado = dataAceptamos_Dev.find(
  //     (option) => option.id === formData["id_aceptamos_devolucion"],
  //   );
  const deposito_destino_Seleccionado = datataller_deposito_destino.find(
    (option) => option.id === formData["id_deposito_destino"],
  );

  // Campos de taller
  const descripcion_Seleccionado = datataller_descripcion.find(
    (option) => option.id === formData["id_descripcion"],
  );
  //   const lote_Seleccionado = datataller_lote.find(
  //     (option) => option.id === formData["id_lote"],
  //   );
  const falla_Seleccionado = datataller_falla.find(
    (option) => option.id === formData["id_falla"],
  );
  const componente_Seleccionado = datataller_componente.find(
    (option) => option.id === formData["id_componente"],
  );
  //   const estetica_packaging_Seleccionado = datataller_estetica_packaging.find(
  //     (option) => option.id === formData["id_estetica_packaging"],
  //   );
  //   const estetica_producto_Seleccionado = datataller_estetica_producto.find(
  //     (option) => option.id === formData["id_estetica_producto"],
  //   );
  const numero_serie_Seleccionado = formData["numero_serie"];
  const deposito_destino_taller_Seleccionado = datataller_deposito_destino.find(
    (option) => option.id === formData["id_deposito_destino"],
  );
  const reparacion_Seleccionado = datataller_reparacion.find(
    (option) => option.id === formData["id_reparacion"],
  );
  const motivo_del_scrap_Seleccionado = datataller_motivo_del_scrap.find(
    (option) => option.id === formData["id_motivo_scrap"],
  );
  // const codigo_barra_Seleccionado = formData["codigo_barra"];
  const estado_sku_Seleccionado = datataller_estado_sku.find(
    (option) => option.id === formData["id_estado_sku"],
  );
  const responsable_Seleccionado = datataller_responsable.find(
    (option) => option.id === formData["id_responsable"],
  );
  const comentarios_Seleccionado = formData["comentarios"];

  // Debug: Log formData to see the actual field names (temporary for debugging)
  // console.log('formData in Admin_Form_Body_Taller:', formData);
  // console.log('Available datataller arrays:', {
  // 	datataller_descripcion: datataller_descripcion.length,
  // 	datataller_lote: datataller_lote.length,
  // 	datataller_falla: datataller_falla.length,
  // 	datataller_componente: datataller_componente.length,
  // 	datataller_estetica_packaging: datataller_estetica_packaging.length,
  // 	datataller_estetica_producto: datataller_estetica_producto.length,
  // 	datataller_deposito_destino: datataller_deposito_destino.length,
  // 	datataller_reparacion: datataller_reparacion.length,
  // 	datataller_motivo_del_scrap: datataller_motivo_del_scrap.length,
  // 	datataller_estado_sku: datataller_estado_sku.length,
  // 	datataller_responsable: datataller_responsable.length
  // });

  //Función para habilitar o bloquear botón de Enviar una vez que haya datos en cada Input
  const isFormValid = useMemo(() => {
    // Campos base de Admin_Form_Body
    const baseRequiredFields = [
      "id_origen_dev",
      "id_deposito_dest",
      "id_sintoma",
    ];

    // Agregar campo condicional de depósito destino
    const conditionalFields =
      deposito_dest_Seleccionado && !deposito_dest_Seleccionado.isworkshop
        ? ["id_deposito_destino"]
        : [];

    // Campos de taller
    const tallerRequiredFields = [
      "id_descripcion",
      "id_falla",
      "id_componente",
      "id_deposito_destino",
      "id_reparacion",
      "id_estado_sku",
      "id_responsable",
    ];

    const requiredFields = [
      ...baseRequiredFields,
      ...conditionalFields,
      ...tallerRequiredFields,
    ];

    if (
      deposito_destino_taller_Seleccionado &&
      deposito_destino_taller_Seleccionado.name.includes("Reacondicionado")
    ) {
      requiredFields.push("numero_serie");
    }

    if (
      deposito_destino_taller_Seleccionado &&
      deposito_destino_taller_Seleccionado.name.includes("Perdida")
    ) {
      requiredFields.push("id_motivo_scrap");
      requiredFields.push("comentarios");
    }

    if (motivo_del_scrap_Seleccionado) {
      requiredFields.push("comentarios");
    }

    // Verifica si alguno de los campos requeridos está vacío
    return requiredFields.every((field) => {
      const value = formData[field];
      if (typeof value === "string") {
        return value.trim() !== "";
      } else {
        return value !== null && value !== undefined && value !== 0;
      }
    });
  }, [
    formData,
    deposito_dest_Seleccionado,
    deposito_destino_taller_Seleccionado,
    motivo_del_scrap_Seleccionado,
  ]);

  return (
    <>
      {isLoading ? (
        <></>
      ) : (
        <>
          <Box sx={{ flexGrow: 1, marginTop: "8px", marginBottom: "16px" }}>
            <Grid
              container
              spacing={{ xs: 2, md: 3 }}
              columns={{ xs: 4, sm: 8, md: 12 }}
            >
              {/* Campos de Admin_Form_Body */}

              {/* <Grid item xs={12} sm={4} md={4} key="admin-3">
                <InputAutocomplete
                  id="id_condicion"
                  value={condicion_Seleccionado || null}
                  label="Condición"
                  onChange={(event, newValue) =>
                    handleChangeAutoComplete("id_condicion", newValue)
                  }
                  error={
                    touched["id_condicion"] && Boolean(errors["id_condicion"])
                  }
                  onBlur={() => handleBlur("id_condicion")}
                  required={true}
                  helperText={
                    touched["id_condicion"] ? errors["id_condicion"] : ""
                  }
                  disabled={!hasAdminPermission}
                  options={
                    dataCondicion
                      ? dataCondicion.map((condicion) => ({
                          name: condicion.name,
                          id: condicion.id,
                        }))
                      : options_condicion
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                />
              </Grid> */}

              {/* <Grid item xs={12} sm={4} md={4} key="admin-5">
                <InputAutocomplete
                  id="id_aceptamos_devolucion"
                  value={aceptamos_dev_Seleccionado || null}
                  label="Aceptamos la devolucion"
                  onChange={(event, newValue) =>
                    handleChangeAutoComplete(
                      "id_aceptamos_devolucion",
                      newValue,
                    )
                  }
                  error={
                    touched["id_aceptamos_devolucion"] &&
                    Boolean(errors["id_aceptamos_devolucion"])
                  }
                  onBlur={() => handleBlur("id_aceptamos_devolucion")}
                  required={true}
                  helperText={
                    touched["id_aceptamos_devolucion"]
                      ? errors["id_aceptamos_devolucion"]
                      : ""
                  }
                  disabled={!hasAdminPermission}
                  options={
                    dataAceptamos_Dev
                      ? dataAceptamos_Dev.map((condicion) => ({
                          name: condicion.name,
                          id: condicion.id,
                        }))
                      : data_aceptamos_devolucion
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  getOptionLabel={(option) => option.nombre_estado || ""}
                />
              </Grid> */}

              {/* Campo condicional de Depósito Destino */}
              {/* {deposito_dest_Seleccionado &&
                !deposito_dest_Seleccionado.isworkshop && (
                  <Grid item xs={12} sm={4} md={4} key="admin-6">
                    <InputAutocomplete
                      id="id_deposito_destino"
                      value={deposito_destino_Seleccionado || null}
                      label="Depósito destino"
                      onChange={(event, newValue) =>
                        handleChangeAutoComplete(
                          "id_deposito_destino",
                          newValue,
                        )
                      }
                      error={
                        touched["id_deposito_destino"] &&
                        Boolean(errors["id_deposito_destino"])
                      }
                      onBlur={() => handleBlur("id_deposito_destino")}
                      required={true}
                      helperText={
                        touched["id_deposito_destino"]
                          ? errors["id_deposito_destino"]
                          : ""
                      }
                      disabled={!hasAdminPermission}
                      options={
                        datataller_deposito_destino
                          ? datataller_deposito_destino.map((condicion) => ({
                              name: condicion.name,
                              id: condicion.id,
                            }))
                          : options_deposito_destino
                      }
                      isOptionEqualToValue={(option, value) =>
                        option.id === value.id
                      }
                    />
                  </Grid>
                )} */}

              {/* Separador visual */}
              <Grid item xs={12} key="separator">
                {/* <hr className="spacing_line" /> */}
                <h3 style={{ margin: "16px 0 8px 0", color: "#666" }}>
                  Campos de Taller
                </h3>
              </Grid>

              {/* Campos de Taller */}
              {hasAdminPermission && (
                <>
                  <Grid item xs={12} sm={4} md={4} key="admin-1">
                    <InputAutocomplete
                      id="id_origen_dev"
                      value={origenDevSeleccionado || null}
                      label="Origen Devolución"
                      onChange={(event, newValue) =>
                        handleChangeAutoComplete("id_origen_dev", newValue)
                      }
                      error={Boolean(
                        touched?.["id_origen_dev"] && errors?.["id_origen_dev"],
                      )}
                      onBlur={() => handleBlur("id_origen_dev")}
                      required={true}
                      helperText={
                        touched["id_origen_dev"] && errors["id_origen_dev"]
                      }
                      disabled={!hasAdminPermission}
                      options={
                        dataOrigen_devolucion
                          ? dataOrigen_devolucion.map((condicion) => ({
                              name: condicion.name,
                              id: condicion.id,
                            }))
                          : options_origen_devolucion
                      }
                      isOptionEqualToValue={(option, value) =>
                        option.id === value.id
                      }
                      getOptionLabel={(option) => option.name || ""}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4} key="admin-2">
                    <InputAutocomplete
                      id="id_deposito_dest"
                      value={deposito_dest_Seleccionado || null}
                      label="Destino Devolución"
                      onChange={(event, newValue) => {
                        handleChangeAutoComplete("id_deposito_dest", newValue);
                        handleChangeAutoComplete("id_deposito_destino", null);
                      }}
                      error={
                        touched["id_deposito_dest"] &&
                        Boolean(errors["id_deposito_dest"])
                      }
                      onBlur={() => handleBlur("id_deposito_dest")}
                      required={true}
                      helperText={
                        touched["id_deposito_dest"]
                          ? errors["id_deposito_dest"]
                          : ""
                      }
                      disabled={!hasAdminPermission}
                      options={
                        dataDeposito_destino
                          ? dataDeposito_destino.map((condicion) => ({
                              name: condicion.name,
                              id: condicion.id,
                            }))
                          : options_deposito_destino
                      }
                      isOptionEqualToValue={(option, value) =>
                        option.id === value.id
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4} key="admin-4">
                    <InputAutocomplete
                      id="id_sintoma"
                      value={sintoma_Seleccionado || null}
                      label="Síntoma"
                      onChange={(event, newValue) =>
                        handleChangeAutoComplete("id_sintoma", newValue)
                      }
                      error={
                        touched["id_sintoma"] && Boolean(errors["id_sintoma"])
                      }
                      onBlur={() => handleBlur("id_sintoma")}
                      required={true}
                      helperText={
                        touched["id_sintoma"] ? errors["id_sintoma"] : ""
                      }
                      disabled={!hasAdminPermission}
                      options={
                        dataSintoma
                          ? dataSintoma.map((condicion) => ({
                              name: condicion.name,
                              id: condicion.id,
                            }))
                          : options_sintoma
                      }
                      isOptionEqualToValue={(option, value) =>
                        option.id === value.id
                      }
                    />
                  </Grid>
                </>
              )}
              <Grid item xs={12} sm={4} md={4} key="6">
                <InputAutocomplete
                  id="id_descripcion"
                  value={descripcion_Seleccionado || null}
                  label="Descripción"
                  onChange={(event, newValue) =>
                    handleChangeAutoComplete("id_descripcion", newValue)
                  }
                  error={
                    touched["id_descripcion"] &&
                    Boolean(errors["id_descripcion"])
                  }
                  onBlur={() => handleBlur("id_descripcion")}
                  required={true}
                  helperText={
                    touched["id_descripcion"] ? errors["id_descripcion"] : ""
                  }
                  disabled={!hasAdminPermission}
                  options={
                    datataller_descripcion
                      ? datataller_descripcion.map((condicion) => ({
                          name: condicion.name,
                          id: condicion.id,
                        }))
                      : options_condicion
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                />
              </Grid>
              {/* <Grid item xs={12} sm={4} md={4} key="7">
                <InputAutocomplete
                  id="id_lote"
                  value={lote_Seleccionado || null}
                  label="Lote"
                  onChange={(event, newValue) =>
                    handleChangeAutoComplete("id_lote", newValue)
                  }
                  error={touched["id_lote"] && Boolean(errors["id_lote"])}
                  onBlur={() => handleBlur("id_lote")}
                  required={true}
                  helperText={touched["id_lote"] ? errors["id_lote"] : ""}
                  disabled={!hasAdminPermission}
                  options={
                    datataller_lote
                      ? datataller_lote.map((condicion) => ({
                          name: condicion.name,
                          id: condicion.id,
                        }))
                      : options_aceptamos_devolucion_safe
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                />
              </Grid> */}
              <Grid item xs={12} sm={4} md={4} key="8">
                <InputAutocomplete
                  id="id_falla"
                  value={falla_Seleccionado || null}
                  label="Falla"
                  onChange={(event, newValue) =>
                    handleChangeAutoComplete("id_falla", newValue)
                  }
                  error={touched["id_falla"] && Boolean(errors["id_falla"])}
                  onBlur={() => handleBlur("id_falla")}
                  required={true}
                  helperText={touched["id_falla"] ? errors["id_falla"] : ""}
                  disabled={!hasAdminPermission}
                  options={
                    datataller_falla
                      ? datataller_falla.map((condicion) => ({
                          name: condicion.name,
                          id: condicion.id,
                        }))
                      : options_aceptamos_devolucion_safe
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                />
              </Grid>
              <Grid item xs={12} sm={4} md={4} key="9">
                <InputAutocomplete
                  id="id_componente"
                  value={componente_Seleccionado || null}
                  label="Componente"
                  onChange={(event, newValue) =>
                    handleChangeAutoComplete("id_componente", newValue)
                  }
                  error={Boolean(
                    touched?.["id_componente"] && errors?.["id_componente"],
                  )}
                  onBlur={() => handleBlur("id_componente")}
                  required={true}
                  helperText={
                    touched["id_componente"] && errors["id_componente"]
                  }
                  disabled={!hasAdminPermission}
                  options={
                    datataller_componente
                      ? datataller_componente.map((condicion) => ({
                          name: condicion.name,
                          id: condicion.id,
                        }))
                      : options_origen_devolucion
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                />
              </Grid>
              {/* <Grid item xs={12} sm={4} md={4} key="10">
                <InputAutocomplete
                  id="id_estetica_packaging"
                  value={estetica_packaging_Seleccionado || null}
                  label="Estética Packaging"
                  onChange={(event, newValue) =>
                    handleChangeAutoComplete("id_estetica_packaging", newValue)
                  }
                  error={
                    touched["id_estetica_packaging"] &&
                    Boolean(errors["id_estetica_packaging"])
                  }
                  onBlur={() => handleBlur("id_estetica_packaging")}
                  required={true}
                  helperText={
                    touched["id_estetica_packaging"]
                      ? errors["id_estetica_packaging"]
                      : ""
                  }
                  disabled={!hasAdminPermission}
                  options={
                    datataller_estetica_packaging
                      ? datataller_estetica_packaging.map((condicion) => ({
                          name: condicion.name,
                          id: condicion.id,
                        }))
                      : options_aceptamos_devolucion_safe
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                />
              </Grid> */}
              {/* <Grid item xs={12} sm={4} md={4} key="11">
                <InputAutocomplete
                  id="id_estetica_producto"
                  value={estetica_producto_Seleccionado || null}
                  label="Estética Producto"
                  onChange={(event, newValue) =>
                    handleChangeAutoComplete("id_estetica_producto", newValue)
                  }
                  error={
                    touched["id_estetica_producto"] &&
                    Boolean(errors["id_estetica_producto"])
                  }
                  onBlur={() => handleBlur("id_estetica_producto")}
                  required={true}
                  helperText={
                    touched["id_estetica_producto"]
                      ? errors["id_estetica_producto"]
                      : ""
                  }
                  disabled={!hasAdminPermission}
                  options={
                    datataller_estetica_producto
                      ? datataller_estetica_producto.map((condicion) => ({
                          name: condicion.name,
                          id: condicion.id,
                        }))
                      : options_aceptamos_devolucion_safe
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                />
              </Grid> */}
              <Grid item xs={12} sm={4} md={4} key="12">
                <TextField
                  sx={{
                    width: "100%",
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "#fff",
                      borderRadius: "8px",
                    },
                    "& .MuiInputBase-input": {
                      backgroundColor: "#fff !important",
                      borderRadius: "8px",
                      WebkitBoxShadow: "0 0 0 1000px white inset",
                    },
                  }}
                  id="numero_serie"
                  label="Número de Serie"
                  value={numero_serie_Seleccionado || ""}
                  required={
                    deposito_destino_taller_Seleccionado &&
                    deposito_destino_taller_Seleccionado.name.includes(
                      "Reacondicionado",
                    )
                  }
                  onChange={(event) =>
                    handleChangeAutoComplete("numero_serie", event.target.value)
                  }
                  disabled={!hasAdminPermission}
                />
              </Grid>
              <Grid item xs={12} sm={4} md={4} key="13">
                <InputAutocomplete
                  id="id_deposito_destino"
                  value={deposito_destino_Seleccionado || null}
                  label="Depósito destino"
                  onChange={(event, newValue) =>
                    handleChangeAutoComplete("id_deposito_destino", newValue)
                  }
                  error={
                    touched["id_deposito_destino"] &&
                    Boolean(errors["id_deposito_destino"])
                  }
                  onBlur={() => handleBlur("id_deposito_destino")}
                  required={true}
                  helperText={
                    touched["id_deposito_destino"]
                      ? errors["id_deposito_destino"]
                      : ""
                  }
                  disabled={!hasAdminPermission}
                  options={
                    datataller_deposito_destino
                      ? datataller_deposito_destino.map((condicion) => ({
                          name: condicion.name,
                          id: condicion.id,
                        }))
                      : options_deposito_destino
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                />
              </Grid>
              <Grid item xs={12} sm={4} md={4} key="14">
                <InputAutocomplete
                  id="id_reparacion"
                  value={reparacion_Seleccionado || null}
                  label="Reparación"
                  onChange={(event, newValue) =>
                    handleChangeAutoComplete("id_reparacion", newValue)
                  }
                  error={
                    touched["id_reparacion"] && Boolean(errors["id_reparacion"])
                  }
                  onBlur={() => handleBlur("id_reparacion")}
                  required={true}
                  helperText={
                    touched["id_reparacion"] ? errors["id_reparacion"] : ""
                  }
                  disabled={!hasAdminPermission}
                  options={
                    datataller_reparacion
                      ? datataller_reparacion.map((condicion) => ({
                          name: condicion.name,
                          id: condicion.id,
                        }))
                      : options_aceptamos_devolucion_safe
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                />
              </Grid>
              <Grid item xs={12} sm={4} md={4} key="15">
                <InputAutocomplete
                  id="id_motivo_scrap"
                  value={motivo_del_scrap_Seleccionado || null}
                  label="Motivo del Scrap"
                  required={
                    deposito_destino_taller_Seleccionado &&
                    deposito_destino_taller_Seleccionado.name.includes(
                      "Perdida",
                    )
                  }
                  onChange={(event, newValue) =>
                    handleChangeAutoComplete("id_motivo_scrap", newValue)
                  }
                  disabled={!hasAdminPermission}
                  options={
                    datataller_motivo_del_scrap
                      ? datataller_motivo_del_scrap.map((condicion) => ({
                          name: condicion.name,
                          id: condicion.id,
                        }))
                      : options_aceptamos_devolucion_safe
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                />
              </Grid>
              {/* <Grid item xs={12} sm={4} md={4} key="16">
                <TextField
                  sx={{ width: "100%" }}
                  id="codigo_barra"
                  label="Código de Barra"
                  required={
                    deposito_destino_taller_Seleccionado &&
                    deposito_destino_taller_Seleccionado.name.includes(
                      "Reacondicionado",
                    )
                  }
                  value={codigo_barra_Seleccionado || ""}
                  onChange={(event) =>
                    handleChangeAutoComplete("codigo_barra", event.target.value)
                  }
                  disabled={!hasAdminPermission}
                />
              </Grid> */}
              <Grid item xs={12} sm={4} md={4} key="17">
                <InputAutocomplete
                  id="id_estado_sku"
                  value={estado_sku_Seleccionado || null}
                  label="Estado del SKU"
                  onChange={(event, newValue) =>
                    handleChangeAutoComplete("id_estado_sku", newValue)
                  }
                  error={
                    touched["id_estado_sku"] && Boolean(errors["id_estado_sku"])
                  }
                  onBlur={() => handleBlur("id_estado_sku")}
                  required={true}
                  helperText={
                    touched["id_estado_sku"] ? errors["id_estado_sku"] : ""
                  }
                  disabled={!hasAdminPermission}
                  options={
                    datataller_estado_sku
                      ? datataller_estado_sku.map((condicion) => ({
                          name: condicion.name,
                          id: condicion.id,
                        }))
                      : options_sintoma
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                />
              </Grid>
              <Grid item xs={12} sm={4} md={4} key="18">
                <InputAutocomplete
                  id="id_responsable"
                  value={responsable_Seleccionado || null}
                  label="Responsable"
                  onChange={(event, newValue) =>
                    handleChangeAutoComplete("id_responsable", newValue)
                  }
                  error={
                    touched["id_responsable"] &&
                    Boolean(errors["id_responsable"])
                  }
                  onBlur={() => handleBlur("id_responsable")}
                  required={true}
                  helperText={
                    touched["id_responsable"] ? errors["id_responsable"] : ""
                  }
                  disabled={!hasAdminPermission}
                  options={
                    datataller_responsable
                      ? datataller_responsable.map((condicion) => ({
                          name: condicion.name,
                          id: condicion.id,
                        }))
                      : options_aceptamos_devolucion_safe
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                />
              </Grid>
              <Grid item xs={12} key="19">
                <TextField
                  sx={{
                    width: "100%",
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "#fff",
                      borderRadius: "8px",
                    },
                    "& .MuiOutlinedInput-input": {
                      backgroundColor: "#fff !important",
                      borderRadius: "8px",
                      WebkitBoxShadow: "0 0 0 1000px white inset",
                    },
                  }}
                  id="comentarios"
                  label="Comentarios"
                  value={comentarios_Seleccionado || ""}
                  required={
                    motivo_del_scrap_Seleccionado ||
                    (deposito_destino_taller_Seleccionado &&
                      deposito_destino_taller_Seleccionado.name.includes(
                        "Perdida",
                      ))
                  }
                  onChange={(event) =>
                    handleChangeAutoComplete("comentarios", event.target.value)
                  }
                  disabled={!hasAdminPermission}
                />
              </Grid>
            </Grid>
          </Box>

          <div className="send_btn_container_admin">
            {/* <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            onClick={(e) => handleSubmit(e, 'reopen')} // pasar 'reopen' como tipo de acción
                        >
                            Re abrir
                        </Button>  */}

            <Button
              type="submit"
              variant="contained"
              style={{
                color:
                  !isFormValid || isLoading || isSubmitting
                    ? "rgba(0, 0, 0, 0.26)"
                    : "white",
                backgroundColor:
                  !isFormValid || isLoading || isSubmitting
                    ? "#0000001F"
                    : "#002878",
                "&:hover": {
                  backgroundColor:
                    !isFormValid || isLoading || isSubmitting
                      ? "#0000001F"
                      : "#002878",
                },
                width: "150px",
                textTransform: "uppercase",
              }}
              disabled={!isFormValid || isLoading || isSubmitting}
              onClick={(e) => handleSubmit(e, "finalize")} // pasar 'finalize' como tipo de acción
            >
              Finalizar
            </Button>
          </div>
        </>
      )}
    </>
  );
};

export default Admin_Form_Body_Taller;
